export default "__VITE_ASSET__BGPy91H4__"